import * as React from 'react'
import { cn } from '../../lib/utils'

function DealCard({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
	return (
		<div
			data-slot="deal-card"
			className={cn(
				'flex flex-col gap-3 overflow-hidden rounded-lg border border-(--color-border) bg-(--color-background) p-4',
				className
			)}
			{...props}
		/>
	)
}

DealCard.displayName = 'DealCard'

function DealCardHeader({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
	return (
		<div
			data-slot="deal-card-header"
			className={cn('flex items-center gap-3', className)}
			{...props}
		/>
	)
}

DealCardHeader.displayName = 'DealCardHeader'

function DealCardTitle({ className, ...props }: React.HTMLAttributes<HTMLParagraphElement>) {
	return (
		<p
			data-slot="deal-card-title"
			className={cn('flex-1 text-sm font-medium leading-none text-(--color-foreground)', className)}
			{...props}
		/>
	)
}

DealCardTitle.displayName = 'DealCardTitle'

function DealCardFields({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
	return (
		<div
			data-slot="deal-card-fields"
			className={cn('flex flex-col gap-3', className)}
			{...props}
		/>
	)
}

DealCardFields.displayName = 'DealCardFields'

export interface DealCardFieldProps extends React.HTMLAttributes<HTMLDivElement> {
	label: string
}

function DealCardField({ label, children, className, ...props }: DealCardFieldProps) {
	return (
		<div
			data-slot="deal-card-field"
			className={cn('flex items-center gap-5 text-sm', className)}
			{...props}
		>
			<span className="w-[195px] shrink-0 text-(--color-muted-foreground)">{label}</span>
			<span className="min-w-0 text-(--color-foreground)">{children}</span>
		</div>
	)
}

DealCardField.displayName = 'DealCardField'

function DealCardBody({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
	return (
		<div
			data-slot="deal-card-body"
			className={cn('flex flex-col gap-3', className)}
			{...props}
		/>
	)
}

DealCardBody.displayName = 'DealCardBody'

function DealCardFooter({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
	return (
		<div
			data-slot="deal-card-footer"
			className={cn('flex items-center justify-between', className)}
			{...props}
		/>
	)
}

DealCardFooter.displayName = 'DealCardFooter'

export {
	DealCard,
	DealCardHeader,
	DealCardTitle,
	DealCardFields,
	DealCardField,
	DealCardBody,
	DealCardFooter,
}
